import { css } from '@emotion/react';
import { tokens } from '@flysas-tech/commercial-ui';

import { Section } from '../atoms';

import { FooterLogoIcon } from './icons';

const styles = {
  topSection: css`
    padding: ${tokens.dimension['space-8']} 0;
    background-color: ${tokens.color.gray[20]};
    color: ${tokens.color.white};
  `,
  content: css`
    margin-top: ${tokens.dimension['space-8']};
  `,
  bottomSection: css`
    padding: ${tokens.dimension['space-8']} 0;
    background-color: ${tokens.color.brand};
    color: ${tokens.color.white};
  `,
  links: css`
    width: 100%;
    display: flex;
    gap: ${tokens.dimension['space-4']};
  `,
  followUs: css`
    flex: 1;
    text-align: end;
  `,
};

export function Footer() {
  return (
    <footer>
      <div css={styles.topSection}>
        <Section>
          <FooterLogoIcon />

          <div css={styles.content}>
            <div>{'TRAFFIC INFORMATION'}</div>
            <div>{'Travel update'}</div>
          </div>
        </Section>
      </div>

      <div css={styles.bottomSection}>
        <Section>
          <div css={styles.links}>
            <span>{'Terms of use'}</span>
            <span>{'Conditions of carriage'}</span>
            <span>{'Cookies'}</span>
            <span>{'Manage my data'}</span>
            <span css={styles.followUs}>{'Follow us'}</span>
          </div>
        </Section>
      </div>
    </footer>
  );
}
